"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = constant;

function constant(x) {
  return () => x;
}


//////////////////
// WEBPACK FOOTER
// ./~/victory-vendor/lib-vendor/d3-array/src/constant.js
// module id = ./node_modules/victory-vendor/lib-vendor/d3-array/src/constant.js
// module chunks = 1